import { render } from "./CustomerNotesList.vue?vue&type=template&id=3037ee7f"
import script from "./CustomerNotesList.vue?vue&type=script&lang=js"
export * from "./CustomerNotesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__